// extracted by mini-css-extract-plugin
export default {"dropzone-47":"filesUploader_dropzone-47__xC1Dp","styled":"filesUploader_styled__Hpmjx","borderless":"filesUploader_borderless__Wag48"};